import { render, staticRenderFns } from "./gatewayg.vue?vue&type=template&id=19afc3dd"
import script from "./gatewayg.vue?vue&type=script&lang=js"
export * from "./gatewayg.vue?vue&type=script&lang=js"
import style0 from "./gatewayg.vue?vue&type=style&index=0&id=19afc3dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports